import React from 'react';
import Button from '../ui/Button';

const CTASection = () => {
  return (
    <section className="on-navy bg-rn-navy py-16 lg:py-20 text-white text-center">
      <div className="container mx-auto px-6">
        <h2 className="text-[27px] md:text-[32px] font-semibold mb-4">
          Ganhe Tempo com Atividades Repetitivas
        </h2>
        <p className="text-rn-text-soft-dk mb-8 max-w-2xl mx-auto">
          Foque no que mais importa no projeto. Comandos especializados pra cada etapa.
        </p>
        <a href="/#planos">
          <Button size="lg">
            Assinar Agora
          </Button>
        </a>
      </div>
    </section>
  );
};

export default CTASection;